<script setup lang="ts">
import type { PropType } from 'vue'
import type { AdminServicePEStatusType } from '@/entities/Cabinet'

defineProps({
  status: {
    type: Object as PropType<AdminServicePEStatusType>,
    default: null,
  },
})
</script>

<template>
  <div class="text-h6 font-weight-regular mt-n4">{{ $t('itf.chips_state') }}</div>

  <template v-if="status">
    <div class="form__grid_3">
      <div class="form__grid_2">
        <VTable density="comfortable">
          <thead>
            <tr>
              <th class="text-left">{{ $t('itf.inputs') }}</th>
              <th class="text-left">{{ $t('itf.value') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(value, index) in status.i" key="index">
              <td>{{ index }}</td>
              <td>{{ value }}</td>
            </tr>
          </tbody>
        </VTable>

        <VTable density="comfortable">
          <thead>
            <tr>
              <th class="text-left">{{ $t('itf.outputs') }}</th>
              <th class="text-left">{{ $t('itf.value') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(value, index) in status.r" key="index">
              <td>{{ index }}</td>
              <td>{{ value }}</td>
            </tr>
          </tbody>
        </VTable>
      </div>
    </div>
  </template>

  <template v-else>
    <div class="mt-4">
      {{ $t('itf.not_info') }}
    </div>
  </template>
</template>
